module.exports = __webpack_public_path__ + "static/assets/bc74209166daa0e7f87690ea93b6293f.svg";